__turbopack_context__.v({
  "column": "WebcruiterStillinger-module__aHgIOq__column",
  "flexContainer": "WebcruiterStillinger-module__aHgIOq__flexContainer",
  "row": "WebcruiterStillinger-module__aHgIOq__row",
  "stillingPanel": "WebcruiterStillinger-module__aHgIOq__stillingPanel",
  "style": "WebcruiterStillinger-module__aHgIOq__style",
  "tekst": "WebcruiterStillinger-module__aHgIOq__tekst",
});
